import React from "react";
import { lib, event } from "../../index";
import { Button, message, Space } from "antd";
import { SearchList } from "../../config-center-v3";
import axios from "axios";
import RoleAddAccountModal from "./role-add-account-modal";
import RoleAccountCancelPermissionModal from "./role-account-cancel-permission-modal";
import HOC from "../../util/HOC";

@HOC.mapAuthButtonsToState({
    pagePath: "/role-manage",
    buttonCodeArr: ["batchCancelPermission", "cancelPermission", "userAdd"],
})
export default class RoleAddAccount extends SearchList {
    constructor(props) {
        super(props);
        this.state.buttons = [];
    }

    getConfig() {
        return axios.get("https://maria.yang800.com/api/data/v2/687/491").then(res => {
            const data = res.data.data;
            if (data) {
                data.page.api =
                    lib.config.webToken === "admin"
                        ? "/ucenter-admin/role/user/bind/page"
                        : "/ucenter-customer/role/user/bind/page";
            }
            return data;
        });
    }

    reload() {
        this.load();
    }

    renderLeftOperation() {
        return (
            <Space>
                {this.state.buttonAuth?.batchCancelPermission && (
                    <Button type={"primary"} onClick={() => this.bachCancelPermission()}>
                        批量取消权限
                    </Button>
                )}
                <span>
                    当前角色【{lib.getParam("roleName")}】已绑定{this.state.pagination.totalCount ?? "0"}名子账号用户{" "}
                </span>
            </Space>
        );
    }

    renderRightOperation() {
        return (
            <Space>
                {this.state.buttonAuth?.userAdd && (
                    <Button type={"primary"} onClick={() => this.setState({ addModalVisible: true })}>
                        {lib.config.webToken === "admin" ? "添加用户" : "添加员工"}
                    </Button>
                )}
            </Space>
        );
    }

    cancelPermission(row) {
        this.setState({
            cancelRow: [row],
            cancelPermissionModalVisible: true,
        });
    }

    bachCancelPermission() {
        const selectedRows = this.state.selectedRows;
        if (selectedRows?.length) {
            this.setState({
                cancelRow: selectedRows,
                cancelPermissionModalVisible: true,
            });
        } else {
            message.warn("请选择至少一条数据");
        }
    }

    myOperation(row) {
        return (
            <Space>
                {this.state.buttonAuth?.cancelPermission && (
                    <Button type={"link"} onClick={() => this.cancelPermission(row)}>
                        取消权限
                    </Button>
                )}
            </Space>
        );
    }

    renderModal() {
        const { addModalVisible, cancelPermissionModalVisible } = this.state;

        return (
            <>
                <RoleAddAccountModal
                    roleId={lib.getParam("roleId")}
                    visible={addModalVisible}
                    onClose={success => {
                        this.setState({
                            selectedRows: [],
                            selectedIdList: [],
                            addModalVisible: false,
                        });
                        if (success) {
                            event.emit(lib.getParam("refresh_event"), {});
                            this.reload();
                        }
                    }}
                />
                <RoleAccountCancelPermissionModal
                    roleId={lib.getParam("roleId")}
                    roleName={lib.getParam("roleName")}
                    cancelRow={this.state.cancelRow}
                    visible={cancelPermissionModalVisible}
                    onClose={success => {
                        this.setState({
                            cancelPermissionModalVisible: false,
                            selectedRows: [],
                            selectedIdList: [],
                            cancelRow: [],
                        });
                        if (success) {
                            event.emit(lib.getParam("refresh_event"), {});
                            this.reload();
                        }
                    }}
                />
            </>
        );
    }
}
